import * as React from 'react';
import { FormControl, TextField, Button, Container, Box } from '@mui/material';
import { useAppContext } from '../context';

export default function CaptureCode() {
    const appContext = useAppContext();
    const [code, setCode] = React.useState("");

    const onCodeChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value);
    };

    const onSubmit = (e?: React.SubmitEvent<HTMLFormElement>) => {
        e?.preventDefault();
        appContext.navigateToAddressPage(code);
    };

    return (
        <form style={{ width: '100%' }} onSubmit={onSubmit} noValidate autoComplete="off">
            <Container maxWidth="xs">
                <FormControl component="fieldset" style={{ width: '100%' }}>
                    <TextField
                        label="Code"
                        value={code}
                        onChange={onCodeChanged}
                        fullWidth={true} />
                </FormControl>

                <Box my={2} />

                <Button
                    variant="contained"
                    size="large"
                    type="submit"
                    color="primary">Begin</Button>
            </Container>
        </form>
    )
}
